import { Link, Skeleton, Tooltip, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router";

import type { FC, ReactNode } from "react";

/**
 * One of the counts beside the greeting, linking to where those things are: a skeleton until the
 * count arrives, then the count with a tooltip saying whether there is anything new.
 */
export const HeaderCount: FC<{
  icon: ReactNode;
  count: number | null | undefined;
  to: string;
  noneTooltip: string;
  someTooltip: string;
}> = ({ icon, count, to, noneTooltip, someTooltip }) => {
  const loaded = count !== null && count !== undefined;

  return (
    // An empty title shows no tooltip while the count loads. describeChild keeps the count as the
    // link's name, with the tooltip describing it.
    <Tooltip title={loaded ? (count > 0 ? someTooltip : noneTooltip) : ""} describeChild>
      <Link
        component={RouterLink}
        to={to}
        color="inherit"
        underline="hover"
        sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
      >
        {icon}
        <Typography variant="body2">
          {loaded ? `${count} new` : <Skeleton variant="text" width={40} />}
        </Typography>
      </Link>
    </Tooltip>
  );
};
